const warehousesModel = vm => ({
  title: vm.$gettext('Warehouses'),
  endpoint: 'warehouses',
  allowNew: true,
  allowDelete: true,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Reference text to identify the warehouse')
    },
    {
      key: 'contact',
      label: vm.$gettext('Contact'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Name of the contact in the warehouse')
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country ISO Code'),
      sortable: true,
      editable: false,
      required: true,
      description: vm.$gettext('ISO Code pointing to countries, to which country this setting applies for'),
      type: 'select',
      options: 'countries',
      showKey: 'iso_code',
      showField: 'name',
      withSelect: true
    },
    {
      key: 'phone',
      label: vm.$gettext('Phone'),
      editable: false,
      description: vm.$gettext("Warehouse's phone")
    },
    {
      key: 'email',
      label: vm.$gettext('Email'),
      editable: true,
      required: true,
      description: vm.$gettext("Warehouse's email address")
    },
    {
      key: 'place_id',
      label: vm.$gettext('Address'),
      editable: true,
      required: true,
      formatter: (value, key, item) => {
        return item.place.formatted_address
      }
    },
    {
      key: 'address_extra',
      label: vm.$gettext('Address Extra'),
      editable: true,
      required: true,
      description: vm.$gettext('Additional info about the address, like floor and apartment')
    },
    {
      key: 'schedule',
      label: vm.$gettext('Schedule'),
      editable: true,
      required: true,
      description: vm.$gettext('Warehouse schedule, is an array of days which has for each day the schedule'),
      formatter: (value, key, item) => {
        let readable = ''
        const getScheduleGroups = collection => {
          const groups = {}
          collection.forEach((schedule, i) => {
            let hasShifts = false
            if (schedule.businessHours) {
              let scheduleSignature = ''
              const groupSchedule = []
              schedule.businessHours.forEach((shift, n) => {
                const hasHours = shift.from && shift.from !== ''
                if (hasHours) {
                  hasShifts = true
                  groupSchedule.push(shift)
                  scheduleSignature += shift.from + '-' + shift.to
                }
              })
              if (hasShifts) {
                if (groups[scheduleSignature]) {
                  groups[scheduleSignature].days.push(schedule.dayName)
                } else {
                  groups[scheduleSignature] = {
                    days: [schedule.dayName],
                    schedule: groupSchedule
                  }
                }
              }
            }
          })
          return Object.values(groups)
        }
        const scheduleGroups = getScheduleGroups(value)
        if (scheduleGroups.length !== 0) {
          scheduleGroups.forEach((group, i) => {
            readable += group.days.join(', ') + '\n'
            group.schedule.forEach((shift, i) => {
              readable += '\t' + '- From ' + shift.from + ' to ' + shift.to + '\n'
            })
          })
        }
        return readable.replace(/\n/g, '<br>').replace(/\t/g, '&nbsp;&nbsp;')
      }
    }
  ],
  filters: ['id', 'reference', 'contact', 'phone', 'email', 'place.formatted_address', 'country_iso_code'],
  includes: ['place']
})

export default warehousesModel
